<template>
  <div class="account-container enter-container">
    <router-link to="/" class="logo" />
    <div class="enter-container-wrapper">
      <template v-if="step === 1">
        <div class="enter-caption" v-if="isMail">Вход в почту</div>
        <div class="enter-caption" v-else>Вход в кабинет / регистрация</div>

        <div id="payment-form"></div>

        <form class="enter-form" autocomplete="_off">

          <div class="input-containers" :class="{
            'input-containers-error': error,
            'input-containers-error-agreement': error && error.type === 'agreement',
          }">
            <label for="phone">Введите номер телефона</label>
            <div class="input-group">
              <input type="tel" v-model="phone" placeholder="+7 999 123 45 67" v-mask="'+7 ### ### ## ##'" id="phone"
                class="text-input" :class="{ 'text-input-error': error.message }">
              <!--                            <input-success/>-->
              <!--                            <input-error/>-->
            </div>

            <div class="input-group button-group">
              <input type="submit" :value="error.message || 'Продолжить'" class="button blue"
                @click.prevent="handleSubmit">
            </div>

            <!--                        <div class="agreement-container">-->
            <!--                            <input type="checkbox" id="agreement" v-model="agreement">-->
            <!--                            <label for="agreement" class="agreement">-->
            <!--                                Нажимая на кнопку “Продолжить” Вы принимаете <a href="/upload/oferta.pdf"-->
            <!--                                                                                target="_blank">Условия-->
            <!--                                использования сервиса-->
            <!--                                “Финсайт”</a>, даете-->
            <!--                                <a href="/upload/oferta.pdf" target="_blank">согласие на обработку своих персональных-->
            <!--                                    данных</a> и соглашаетесь с условиями-->
            <!--                                <a href="/upload/oferta.pdf" target="_blank">политики-->
            <!--                                    конфиденциальности</a>-->
            <!--                            </label>-->
            <!--                        </div>-->
          </div>
        </form>
        <!--$router.back()-->
        <div class="_bottom" v-if="isMail"><span style="cursor: pointer;" @click="$router.push('/')">Вернуться на
            главную</span></div>
        <div class="_bottom" v-else><span style="cursor: pointer;" @click="$router.push('/')">Вернуться назад</span></div>
      </template>

      <template v-if="step === 2">
        <div class="enter-caption">Регистрация</div>
        <div class="enter-description">
          Данный номер телефона еще не зарегистрирован, задайте пароль для входа.
        </div>
        <form method="post" class="enter-form" autocomplete="off">

          <div class="input-containers" :class="{ 'input-containers-error': error }">
            <div class="input-group" style="display: block;">
              <div class="relative mt-30px">
                <input type="password" placeholder="Пароль" v-model="password" class="text-input"
                  :class="{ 'text-input-error': error.message }">
                <!--                                <input-success/>-->
                <!--                                <input-error/>-->
              </div>
              <div class="relative mt-30px">
                <input type="password" placeholder="Пароль еще раз" v-model="passwordConfirm" class="text-input"
                  :class="{ 'text-input-error': error.message }">
                <!--                                <input-success/>-->
                <!--                                <input-error/>-->
              </div>
            </div>

            <div class="input-group button-group">
              <input type="submit" :value="error.message || 'Зарегистрироваться'" class="button blue"
                @click.prevent="handleSubmit">
            </div>
          </div>
        </form>

        <div class="_bottom"><span style="cursor: pointer;" @click.prevent="step = 1">Назад</span></div>
      </template>

      <template v-if="step === 3">
        <div class="enter-caption">Вход</div>
        <div class="enter-description">
          Данный номер телефона уже зарегистрирован, введите пароль для входа.
        </div>
        <form method="post" class="enter-form" autocomplete="off">

          <div class="input-containers" :class="{ 'input-containers-error': error }">
            <div class="input-group">
              <div class="relative mt-30px">
                <input type="password" placeholder="Пароль" v-model="password" class="text-input"
                  :class="{ 'text-input-error': error.message }">
                <!--                                <input-success/>-->
                <!--                                <input-error/>-->
              </div>
            </div>

            <div class="input-group button-group">
              <input type="submit" :value="error.message || 'Войти'" class="button blue" @click.prevent="handleSubmit">
              <!--                            <a href="#" @click.prevent="step = 4">Забыл пароль</a>-->
            </div>
          </div>
        </form>

        <div class="_bottom"><span style="cursor: pointer;" @click.prevent="step = 4">Забыл пароль</span></div>
        <div class="_bottom"><span style="cursor: pointer;" @click.prevent="step = 1">Назад</span></div>
      </template>

      <template v-if="step === 4">
        <div class="enter-caption">Восстановление доступа</div>
        <div class="enter-description">
          Чтобы создать новый пароль введите код из смс
        </div>
        <form method="post" class="enter-form" autocomplete="off">

          <div class="input-containers" :class="{ 'input-containers-error': error }">
            <div class="input-group">
              <div class="relative mt-30px">
                <input type="text" placeholder="Код" v-model="code" v-mask="'####'" key="code" class="text-input"
                  :class="{ 'text-input-error': error.message }">
                <!--                                <input-success/>-->
                <!--                                <input-error/>-->
              </div>
            </div>

            <div class="input-group button-group">
              <input type="submit" :value="codeSubmitButton" class="button blue" @click.prevent="sendCode"
                :disabled="codeSubmitDisabled" v-show="code.length !== 4">
              <input type="submit" :value="error.message || 'Продолжить'" class="button blue"
                @click.prevent="handleSubmit" v-show="code.length === 4">
            </div>
          </div>
        </form>
      </template>

      <template v-if="step === 5">
        <div class="enter-caption">Восстановление доступа</div>
        <div class="enter-description">
          Задайте новый пароль для входа
        </div>
        <form method="post" class="enter-form" autocomplete="off">

          <div class="input-containers" :class="{ 'input-containers-error': error }">
            <div class="input-group">
              <div class="relative mt-30px">
                <input type="password" placeholder="Пароль" v-model="password" key="password" class="text-input"
                  :class="{ 'text-input-error': error.message }">
                <!--                                <input-success/>-->
                <!--                                <input-error/>-->
              </div>
            </div>
            <div class="input-group">
              <div class="relative mt-30px">
                <input type="password" placeholder="Пароль еще раз" v-model="passwordConfirm" key="passwordConfirm"
                  class="text-input" :class="{ 'text-input-error': error.message }">
                <!--                                <input-success/>-->
                <!--                                <input-error/>-->
              </div>
            </div>

            <div class="input-group button-group">
              <input type="submit" :value="error.message || 'Войти'" class="button blue" @click.prevent="handleSubmit">
            </div>
          </div>
        </form>
      </template>
    </div>
    <footer v-if="!isMail">
      <div class="agreement-container" v-if="step === 1">
        <input type="checkbox" id="agreement" v-model="agreement">
        <label for="agreement" class="agreement">
          Нажимая на кнопку “Продолжить” Вы принимаете <a href="/oferta.pdf" target="_blank">Условия
            использования сервиса
            “Финсайт”</a>, даете
          <a href="/oferta.pdf" target="_blank">согласие на обработку своих персональных
            данных</a> и соглашаетесь с условиями
          <a href="/oferta.pdf" target="_blank">политики
            конфиденциальности</a>
        </label>
      </div>
      <div v-if="false">
        Нажимая на кнопку “Продолжить” и подтверждая номер телефона кодом из<br class="__hide-desktop">
        SMS, Вы принимаете <a href="/oferta.pdf" target="_blank">Условия
          использования сервиса “Финсайт”</a>, даете согласие<br class="__hide-desktop"> на обработку своих
        персональных данных и
        соглашаетесь с
        <a href="/privacy">условиями<br class="__hide-mobile"> политики<br class="__hide-desktop">
          конфиденциальности</a>.
        Стоимость услуги 12 рублей в день, оплата со счета<br class="__hide-desktop">
        телефона.
        Первые 3 дня предоставляются бесплатно.
      </div>
    </footer>
  </div>
</template>
<script>
// import InputError from '@/components/base/InputError';
// import InputSuccess from '@/components/base/InputSuccess';
import request from '@/api/axios';
import eventsBus from '@/api/events';

export default {
  data: () => {
    return {
      phone: '',
      password: '',
      passwordConfirm: '',
      code: '',
      step: 1,
      error: false,
      time: 30,
      seconds: 30,
      agreement: true,
      codeSubmitDisabled: true
    }
  },
  components: {
    // InputError,
    // InputSuccess
  },
  computed: {
    isMail() {
      return this.$route.meta.mail;
    },
    codeSubmitButton: function () {
      if (this.time === 0) return 'Отправить еще раз';
      return 'Отправить еще раз 0:' + (this.time > 9 ? this.time : '0' + this.time);
    }
  },
  watch: {
    phone: function () {
      this.error = false;
    },
    agreement: function () {
      this.error = false;
    },
    password: function () {
      this.error = false;
    },
    passwordConfirm: function () {
      this.error = false;
    },
    code: function () {
      this.error = false;
    },
    step: function (newStep, oldStep) {
      if (newStep === 4 && oldStep !== 4) {
        this.sendCode();
      }
    }
  },
  mounted() {
    eventsBus.$emit('page-ready');

    if (this.$route.params) {
      if (this.$route.params.step && this.$route.params.phone) {
        this.step = this.$route.params.step;
        this.phone = this.$route.params.phone;
      }
    }

    let hash = window.location.hash;
    if (hash) {
      if (hash.indexOf('phone')) {
        this.step = 3;
        this.phone = decodeURI(hash.replace('#phone=', ''));
      }
    }
  },
  methods: {
    async handleSubmit() {
      let phone = this.phone.replace(/\s|\(|\)|-/g, '');
      const backUrl = this.$route.params.backUrl || this.$route.query.backUrl || null;

      if (this.step === 1) {

        if (phone.length !== 12) {
          if (phone.length === 0) {
            this.error = { message: 'Введите номер телефона' };
            return false;
          }
          this.error = { message: 'Номер указан неверно' };
          return false;
        }

        if (!this.agreement) {
          this.error = {
            message: 'Необходимо принять соглашение',
            type: 'agreement'
          };
          return false;
        }

        const checkUser = (await request({ action: 'check_user', options: { phone } })).data; // todo: change req

        if (checkUser.status === false) {
          // this.step = 2;
          this.$router.push({
            name: 'promo',
            params: {
              activateTele2: true,
              phone
            }
          });
          return false;
        } else {
          this.step = 3;
          return false;
        }
      }

      if (this.step === 2 || this.step === 5) {
        if (!this.password) {
          this.error = { message: 'Введите пароль' };
          return false;
        }

        if (!this.passwordConfirm) {
          this.error = { message: 'Подтвердите пароль' };
          return false;
        }

        if (this.password !== this.passwordConfirm) {
          this.error = { message: 'Ошибка подтверждения пароля' };
          return false;
        }

        let response = null;
        if (this.step === 2) {
          response = await request({
            action: 'register',
            options: {
              phone,
              password: this.password
            }
          });
        }

        if (this.step === 5) {
          response = await request({
            action: 'change_password',
            options: {
              phone,
              password: this.password
            }
          });
        }

        if (response?.data?.status === true) {
          this.$store.commit('login', response.data.user);
          if (this.isMail) {
            const mailLink = (await request({ action: 'get_link_to_mail' })).data;
            if (mailLink.link) {
              window.location.href = mailLink.link;
            } else {
              this.$router.push('/profile');
            }
          } else {
            if (backUrl != null) {
              this.$router.push(backUrl);
            } else {
              this.$router.push('/profile');
            }
          }
        }
        return false;
      }

      if (this.step === 3) {
        if (this.password.length === 0) {
          this.error = { message: 'Введите пароль' };
          return false;
        }

        const login = (await request({ action: 'login', options: { phone, password: this.password } })).data;
        if (login.status === false) {
          this.error = { message: 'Пароль неверный' };
          return false;
        }

        this.$store.commit('login', login.user);

        if (this.isMail) {
          const mailLink = (await request({ action: 'get_link_to_mail' })).data;
          if (mailLink.link) {
            window.location.href = mailLink.link;
          } else {
            this.$router.push('/profile');
          }
        } else {
          if (backUrl != null) {
            if (login.user?.payment?.type === 1) {
              this.$router.push(backUrl);
            } else {
              this.$router.push('/profile');
            }
          } else {
            this.$router.push('/profile');
          }
        }
      }

      if (this.step === 4) {
        let isCodeValid = (await request({ action: 'reset_password', options: { phone, code: this.code } })).data;

        if (isCodeValid.status === false) {
          this.error = { message: 'Код неверный' };
          return false;
        }
        this.step = 5;
        return false;
      }
    },
    async sendCode() {
      this.startTimer();
      let phone = this.phone.replace(/\s|\(|\)|-/g, '');
      return await request({ action: 'reset_password', options: { phone } });
    },
    startTimer() {
      this.time = this.seconds;
      this.codeSubmitDisabled = true;
      let interval = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(interval);
          this.codeSubmitDisabled = false;
        }
      }, 1000);
    }
  }
}
</script>

<style scoped>
html body.promo-page.login-page {
  background-image: url('../../assets/img/promo-bg.jpeg');
  background-color: #f5f5f5;
  background-position: center -200px;
  background-size: contain;
  background-repeat: no-repeat;
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 0;
}

/*@media screen and (max-width: 1300px) {*/
@media screen and (max-width: 1000px) {
  html body.promo-page.login-page {
    background-position: -250px -280px;
    background-size: 140%;
  }
}

@media screen and (max-width: 650px) {
  html body.promo-page.login-page {
    /*background-position: -234px -83px;*/
    /*background-size: 200%;*/
    /*background-position: -420px -133px;*/
    /*background-position: -463px -133px;*/
    /*background-size: 270%;*/
    /*background-image: url('../assets/img/promo-bg-m.jpg');*/
    /*background-image: url('../../assets/img/__bg-promo.jpg?v3');*/
    background-image: url('../../assets/img/1.jpeg?v=2');
    background-size: 100%;
    background-position: left top;
  }
}
</style>

<style scoped>
.enter-container {
  max-width: 860px;
  margin: 0 auto;
  position: relative;
  padding: 0 16px;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 130px;
}

.enter-container .logo {
  position: absolute;
  left: 20px;
  top: 20px;
  background-image: url('../../assets/img/login-logo.svg');
  width: 116px;
  height: 36px;
  display: block;
}

/*@media screen and (max-width: 1300px) {*/
@media screen and (max-width: 1000px) {
  .enter-container {
    padding-top: 47px;
  }
}

@media screen and (max-width: 650px) {
  .enter-container {
    padding-top: 250px;
  }
}

.enter-container-wrapper {
  width: 505px;
}

.enter-caption {
  color: #000;
  font-family: 'Gilroy';
  font-weight: bold;
  margin-bottom: 26px;
  font-size: 48px;
  line-height: 56px;
  max-width: 420px;
}

@media screen and (max-width: 650px) {
  .enter-caption {
    margin: 0 auto;
    font-size: 26px;
    line-height: 28px;
    max-width: 220px;
  }
}

.enter-description {
  /*color: #000;*/
  /*margin-bottom: 20px;*/
  /*font-size: 15px;*/
  /**/
  /*display: block !important;*/
  font-family: Circe;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 140%;
  color: #828282;
  margin-bottom: 20px;
}

label {
  display: block !important;
  font-family: Circe;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 140%;
  color: #828282;
}

.text-input {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #e2e2e2;
  padding: 9px 0;
  background-color: transparent;
  width: 100%;
  outline: none;
  margin-bottom: 0;
  font-family: Gilroy;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #000;
}

.text-input-error {
  border-color: red;
}

.text-input::-webkit-input-placeholder {
  color: #bdbdbd;
}

.text-input:-moz-placeholder {
  color: #bdbdbd;
  opacity: 1;
}

.text-input::-moz-placeholder {
  color: #bdbdbd;
  opacity: 1;
}

.text-input:-ms-input-placeholder {
  color: #bdbdbd;
}

.text-input::-ms-input-placeholder {
  color: #bdbdbd;
}

.text-input::placeholder {
  color: #bdbdbd;
}

input[type="submit"] {
  cursor: pointer;
  display: block;
  width: 100%;
  outline: none;
  background: #0f01e5;
  border-radius: 8px;
  color: #fff;
  padding: 16px;
  text-align: center;
  font-size: 16px;
  line-height: 16px;
  margin-top: 32px;
  border: none;
  max-width: 250px;
  font-weight: 600;
}

body footer {
  margin-bottom: 12px;
  padding-top: 48px;
  font-family: Circe;
  font-style: normal;
  font-weight: normal;
  font-size: 8px;
  line-height: 11px;
  text-align: center;
  color: #828282;
  position: relative;
  margin-top: 170px;
  max-width: 505px;
}

body footer a {
  color: #1001e5;
}

._bottom {
  margin-top: 22px;
}

@media screen and (max-width: 650px) {
  ._bottom {
    text-align: center;
  }
}

._bottom span {
  font-family: Gilroy;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #828282;
  text-decoration: underline;
}

._bottom span:hover {
  text-decoration: none;
}

.agreement-container {
  display: flex;
  position: relative;
}

.agreement {
  font-size: 12px;
  margin-left: 10px;
  line-height: 14px;
  font-weight: normal;
  color: #555;
}

.agreement-container input[type="checkbox"] {
  display: none;
}

.agreement-container label {
  position: relative;
  padding-left: 25px;
  margin-left: 0;
  cursor: pointer;
  text-align: left;
}

.agreement-container label:before {
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border: 2px solid #808080;
  position: absolute;
  top: 2px;
  left: 0;
  cursor: pointer;
  border-radius: 1px;
}

.agreement-container label:after {
  content: '';
  display: none;
  width: 8px;
  height: 8px;
  background: #0f01e5;
  border-radius: 1px;
  top: 6px;
  left: 4px;
  position: absolute;
}

.agreement-container input[type="checkbox"]:checked+label:after {
  display: block;
}

@media screen and (max-width: 650px) {

  body footer {
    /*margin-top: 40px;*/
    /*margin-top: 60px;*/
    margin-top: 0;
  }

  form.login-form .input-container {
    max-width: 100%;
  }

  form.login-form {
    /*margin-top: 65px;*/
    margin-top: 80px;
  }

  .enter-container {
    max-width: 100%;
  }

  .enter-caption {
    text-align: center;
    margin-bottom: 36px;
  }

  .enter-container-wrapper {
    width: 100%;
  }

  .text-input {
    font-size: 35px;
    line-height: 40px;
  }

  input[type="submit"] {
    max-width: 100%;
  }
}
</style>